import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "import-icons"
    }}>{`Import Icons`}</h1>
    <h2 {...{
      "id": "current-ui"
    }}>{`"Current" UI`}</h2>
    <p>{`Our iconography comes from the streamline icon set. The design team has designated a subset of those icons as common. We have added to that list for Build. You can see them `}<a parentName="p" {...{
        "href": "https://www.figma.com/file/Hw3JQszjbsSpPDuimL1v96/Build-Icon-Library?node-id=0%3A1"
      }}>{`here`}</a>{`. This script will help import icons into builder-ui should more be added to the common set.`}</p>
    <h2 {...{
      "id": "new-lowkey-ui"
    }}>{`"New" Lowkey UI`}</h2>
    <p>{`In the context of the UI redesign and migration from `}<inlineCode parentName="p">{`styled-components`}</inlineCode>{` to `}<inlineCode parentName="p">{`Tailwind / ShadCN`}</inlineCode>{`, we are now adding icons from the `}<a parentName="p" {...{
        "href": "https://www.figma.com/design/lsJhpj5iFrrz23gg6c9WRi/2025-Platform-Designs?node-id=4469-5676&p=f&m=dev"
      }}>{`2025 Platform Designs Figma`}</a>{`. Like for the "current" UI, there's a script to help import these new icons into the new set. These script files will have to be modified once the redesign and migration are complete to avoid further confusion.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <h3 {...{
      "id": "current-ui-1"
    }}>{`"Current" UI`}</h3>
    <ol>
      <li parentName="ol">{`Export the new svg icons from figma and paste them into `}<inlineCode parentName="li">{`./app/src/icons/raw/`}</inlineCode></li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`node scripts/import-icons`}</inlineCode></li>
      <li parentName="ol">{`Address any errors that come up in the terminal`}</li>
      <li parentName="ol">{`Your icons should now appear in the docs and be accessible through `}<inlineCode parentName="li">{`<Icons.* />`}</inlineCode></li>
    </ol>
    <h3 {...{
      "id": "new-lowkey-ui-1"
    }}>{`"New" Lowkey UI`}</h3>
    <ol>
      <li parentName="ol">{`Export the new svg icons from figma and paste them into `}<inlineCode parentName="li">{`./app/src/icons/raw-lowkey-ui/`}</inlineCode></li>
      <li parentName="ol">{`Until the "Current" UI has been completely phased out, in order to run the script you will need to run `}<inlineCode parentName="li">{`node scripts/import-icons/index-new.js`}</inlineCode></li>
      <li parentName="ol">{`For now, some errors referring to the icons styling are being commented out and fixed directly by asking guidance to the Design team.`}</li>
      <li parentName="ol">{`Until the "Current" UI has been completely phased out, the "New" Lowkey UI icons should be imported with `}<inlineCode parentName="li">{`import * as Icon from '../icons/index-new'`}</inlineCode>{` . Your icons should now appear in the docs and be accessible through `}<inlineCode parentName="li">{`<Icon.* />`}</inlineCode></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      